module.exports = Function.call.bind(Object.prototype.hasOwnProperty);



//////////////////
// WEBPACK FOOTER
// ./~/react-svg/~/prop-types/lib/has.js
// module id = 803
// module chunks = 2